<div class="row">

  <div [className]="personas.length<2 ? 'col-lg-6' : 'col-lg-4'" *ngFor="let persona of personas; let i = index">
    <div class="card">
      <div class="card-body">

        <div class="d-flex align-items-center">
          <app-icono-persona [keyImg]="persona.keyImg" [alt]="persona.nombre"></app-icono-persona>
          <div class="card-title mb-0 ml-3">
            <b> {{persona.nombre.toUpperCase()}}</b>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-lg-6">
            <h6 class="card-subtitle mb-2 ">{{persona.identidad}}</h6>
          </div>
          <div class="col-lg-6 text-right">
            <h6 class="card-subtitle mb-2">{{persona.numeroColegiacion}}</h6>
          </div>
        </div>
        <h6 class="text-muted">{{persona.municipio}}</h6>
        <h6 class="text-muted">{{persona.departamento}}</h6>
        <hr>
        <div class="row">
          <div class="col-lg-8">
            <p *ngIf="!persona.voto" class="text-muted">{{persona.status}}</p>

            <div *ngIf="persona.voto" class="voto">
              <span class="voto-badge">Ya realizó el voto</span>
              <button type="button" class="btn-reimprimir" [disabled]="!persona.idVotacion"
                (click)="imprimirTicket(persona.idVotacion)">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z" />
                  <path fill-rule="evenodd"
                    d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
                  <path fill-rule="evenodd"
                    d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                </svg>
                Reimprimir ticket
              </button>
            </div>

            <p *ngIf="userData['idRol']==1" class="text-muted">L{{persona.monto}}</p>
          </div>
          <div class="col-lg-4 text-right">
            <div *ngIf="persona.estado">
              <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-bookmark-check-fill" fill="green"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z" />
              </svg>
            </div>
            <div *ngIf="!persona.estado">
              <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-bookmark-x-fill" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm2.854 5.146a.5.5 0 1 0-.708.708L7.293 7 6.146 8.146a.5.5 0 1 0 .708.708L8 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L8.707 7l1.147-1.146a.5.5 0 0 0-.708-.708L8 6.293 6.854 5.146z" />
              </svg>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-8">
            <div class="form-check">
              <input [disabled]="personas.length>1 ? false :true" type="checkbox" (change)="onCheckboxChange($event)"
                [(ngModel)]="persona.seleccionado" [checked]="persona.seleccionado" class="form-check-input"
                id="check{{i}}">
              <label class="form-check-label" for="check{{i}}">Cuenta principal</label>
            </div>
          </div>

          <div class="col-lg-4 text-right">
            <a (click)="removePerson(persona)"><svg width="1.3em" height="1.3em" viewBox="0 0 16 16" class="bi bi-x"
                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg></a>
          </div>

        </div>


      </div>
    </div>

  </div>
</div>